import React, { useEffect, useState } from 'react'

import Modal from '../components/modal'
import config from '../config.json'

const MIN_LENGTH = 6

export function validateNewPassword(pw) {
  if (pw.length < MIN_LENGTH) {
    return `La nueva contraseña debe tener al menos ${MIN_LENGTH} caracteres.`
  }
  if (/^\d+$/.test(pw)) {
    return 'La nueva contraseña no puede consistir solo en números.'
  }
  return null
}

const ChangePasswordModal = ({ onClose, Alert, onPasswordChanged }) => {
  const [oldPass, setOldPass] = useState('')
  const [newPass, setNewPass] = useState('')
  const [newPass2, setNewPass2] = useState('')
  const [formError, setFormError] = useState(null)
  const [submitting, setSubmitting] = useState(false)

  useEffect(() => {
    setOldPass('')
    setNewPass('')
    setNewPass2('')
    setFormError(null)
    setSubmitting(false)
  }, [])

  const handleSubmit = () => {
    setFormError(null)

    if (!oldPass) {
      setFormError('Ingrese la contraseña actual.')
      return
    }

    const pwErr = validateNewPassword(newPass)
    if (pwErr) {
      setFormError(pwErr)
      return
    }

    if (newPass !== newPass2) {
      setFormError('Las nuevas contraseñas no coinciden.')
      return
    }

    setSubmitting(true)

    fetch(`${config.apiUrl}/users-password`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', token: config.token },
      body: JSON.stringify({
        previous_password: oldPass,
        new_password: newPass
      })
    })
      .then((res) => res.json())
      .then((response) => {
        if (response.status === 'ok') {
          onClose()
          if (typeof onPasswordChanged === 'function') {
            onPasswordChanged()
          }
        } else {
          Alert({
            title: 'Contraseña',
            msg: response.msg || 'No se pudo cambiar la contraseña.',
            type: 'error'
          })
        }
      })
      .catch(() => {
        Alert({ title: 'Contraseña', msg: config.fetchErrorMsg, type: 'error' })
      })
      .finally(() => {
        setSubmitting(false)
      })
  }

  return (
    <Modal
      title="Cambiar contraseña"
      modalId="change-password-modal"
      modalClose={onClose}
      Alert={Alert}
      width="420px"
    >
      <div className="change-password-modal">
        <label className="change-password-label" htmlFor="change-password-old">
          Contraseña actual
        </label>
        <input
          id="change-password-old"
          className="change-password-input"
          type="password"
          autoComplete="current-password"
          value={oldPass}
          onChange={(e) => setOldPass(e.target.value)}
          disabled={submitting}
        />

        <label className="change-password-label" htmlFor="change-password-new">
          Nueva contraseña
        </label>
        <input
          id="change-password-new"
          className="change-password-input"
          type="password"
          autoComplete="new-password"
          value={newPass}
          onChange={(e) => setNewPass(e.target.value)}
          disabled={submitting}
        />

        <label className="change-password-label" htmlFor="change-password-new2">
          Repetir nueva contraseña
        </label>
        <input
          id="change-password-new2"
          className="change-password-input"
          type="password"
          autoComplete="new-password"
          value={newPass2}
          onChange={(e) => setNewPass2(e.target.value)}
          disabled={submitting}
        />

        <p className="change-password-hint">
          Mínimo {MIN_LENGTH} caracteres; no puede ser solo números. Cualquier otro carácter está permitido,
          incluido el espacio.
        </p>

        {formError && <p className="change-password-error">{formError}</p>}

        <div className="change-password-actions">
          <button type="button" className="modal-btn" onClick={onClose} disabled={submitting}>
            Cancelar
          </button>
          <button type="button" className="modal-btn primary" onClick={handleSubmit} disabled={submitting}>
            {submitting ? 'Guardando…' : 'Guardar'}
          </button>
        </div>
      </div>
    </Modal>
  )
}

export default ChangePasswordModal
